<h3>You have been logged out of the application.  Tap <a href="/">here</a> to log back in and resume using the site.</h3>